(function() {

	'use strict';

	angular.module('ap.worklist.queues')

	/*
	 * ap.worklist.worklistViewCtrl is first controller that paints the worklist.
	 * It initiates query for worklist meta data
	 * Paints the worklist search options
	 */
	.controller('lancer.worklist.recentWorkItemsQueueCtrl', ['$scope', '$controller', '$resource', '$filter', 'csrfObject','contextPath','WorkListViewSrv', '$log',
	                    function($scope, $controller, $resource, $filter, csrfObject, contextPath, WorkListViewSrv, $log) {
		$log.log('created lancer.worklist.recentWorkItemsQueueCtrl');
		
		var self = this;
		self.alternativeStatusMap = {"INPROGRESS":{"INTERNAL":""}, "APPROVE":{"APPROVEWCHANGES":""}, "DECLINE":{"REJECT":""}};
		self.statusDescriptionOverridesMap = {"DECLINE":"Declined"};
	
		angular.extend(self, $controller('ap.worklist.recentWorkItemsQueueCtrl', {$scope: $scope}));
	
		/*
		 * Change to accommodate Lancer business requirements.
		 * Workitmes with status of "Approve With Changes" should be counted with "Approved" workitems.
		 * Workitems with status of "Underwriter Decline" should be counted with "System Declined" workitems.
		 * 
		 */
		self.getWICounts= function(workitems, accessibleStatuses, status){
			var alternativeStatusMap = self.alternativeStatusMap[status];
			if(!alternativeStatusMap){
				alternativeStatusMap = {"":""};
			}
			var statusCount = 0;
			var numWorkitems = workitems.length;
			for (var i = 0; i<numWorkitems; i++){
				var workitemStatus = workitems[i].status;
				if (workitemStatus==status) { 
					statusCount++;
				} else if (workitemStatus in alternativeStatusMap && accessibleStatuses.indexOf(workitemStatus)>-1) {
					// We shouldn't always use the alternative status!  E.g. Agents don't have access to
					//   INTERNAL from the quotes section, even though it's listed as an alternative status.
					statusCount++;
				}
			}
			return statusCount;
		};
		
		self.lookupValue = function(key, code){
			if(self.statusDescriptionOverridesMap[code]){
				return self.statusDescriptionOverridesMap[code];
			}
			return WorkListViewSrv.lookupValue(key,code);
		};
		
		self.lookupStatusQueryParam = function(accessibleStatuses, status){
			var alternativeStatusMap = self.alternativeStatusMap[status];
			if (alternativeStatusMap) {
				angular.forEach(alternativeStatusMap, function(value, key) {
					// We shouldn't always add the alternative status!  E.g. Agents don't have access to
					//   INTERNAL from the quotes section, even though it's listed as an alternative status.
					if (accessibleStatuses.indexOf(key)>-1) {
						status += "|";
						status += key;
					}
				});
			}
			return status;
		};
}]);

})();